export const notificationsConstants = {
  REQUEST_RECENT_NOTIFICATIONS: 'REQUEST_RECENT_NOTIFICATIONS',
  REQUEST_RECENT_NOTIFICATIONS_FINISHED: 'REQUEST_RECENT_NOTIFICATIONS_FINISHED',
  REQUEST_ALL_NOTIFICATIONS: 'REQUEST_ALL_NOTIFICATIONS',
  REQUEST_ALL_NOTIFICATIONS_FINISHED: 'REQUEST_ALL_NOTIFICATIONS_FINISHED'
};